<object class="my-4" #mapObject [attr.data]="mapUrl" alt="Election map" type="image/svg+xml" style="--width:{{width}}px;--height:{{height}}px" tabindex="-1" aria-hidden="true">
    This is a map
</object>
